import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component} from "react"
import {Link} from "react-router-dom"
import {Message, Menu, Modal, Button, Icon} from "semantic-ui-react"
import {Row, Col, Form, FormField, FormInput} from "elemental-react16"
import {withRouter} from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"
import htmr                                                                           from "htmr";

@withRouter
export default class LoginPage extends Component {
	constructor() {
		super()
		this.state = {
			user    : "",
			password: ""
		}
		shop.whoami()
	}

	handleLogin = ( e ) => {
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.login( {...this.state} )
			.catch( ( err ) => {
				console.error( err )
				shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
				return false
			} )
			.then( session => {
				if ( !session ) return
				shop.loadCategories()
				shop.cart.hydrate()
				shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
				let redirectTo = referrer || shop.locationAfterLogin
				console.log( "AFTER", redirectTo )
				if ( redirectTo ) {
					history.push( redirectTo )
				} else {
					history.push( "/home" )
				}
			} )

		e.preventDefault()
	}

	handleUserChange = ( event ) => {
		this.setState( {
			user: event.target.value
		} )
	}

	handlePasswordChange = ( event ) => {
		this.setState( {
			password: event.target.value
		} )
	}

	render() {
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		return (
			<div className="LoginPage pb6 cssOptima">
				<div className=" container">
					<div className="black absolute top-0 right-2 pt2">
						<LanguageDropdown />
					</div>

					<section>
						<Row>
							<Col className="tc "
								 style={{marginTop: "120px"}}>
								<Link className={"logo"} to="/home/" >
									<img style={{maxWidth: "400px", width: "100%"}}
										src={shop.config.logo}
										alt="" />
								</Link>
							</Col>
						</Row>
					</section>


					<WordPressContainer postType={"shop"} slug={"login"} />

					<Row>
						<Col sm="4/12"> </Col>
						<Col sm="4/12">
							<div className="mw6 cssLindtGrey"
								 style={{marginTop: "60px"}}>
								<Form onSubmit={this.handleLogin}>
									<FormField label={<p className="cssLindtGrey">{translate("Ihre Lindt Kunden-Nr.")}</p>}
											   title={translate("Kunden-Nr.")}
											   htmlFor="basic-form-input-email">
										<FormInput style={{backgroundColor: "#F2EBD8", border: "1px solid #917236",}} value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={translate("Ihre Lindt Kunden-Nr.")}
												   name="basic-form-input-id" />
									</FormField>
									<FormField label={<p className="cssLindtGrey">{translate("Passwort")}</p>}
											   htmlFor="basic-form-input-password">
										<FormInput style={{backgroundColor: "#F2EBD8", border: "1px solid #917236"}} value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</FormField>
									{/*<FormField>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</FormField>*/}
									<div className="tc pt3 ">
										<Button className="fw7"
											primary
											submit
										>{translate( "ANMELDEN" )}</Button>
										<Link className="db mt3 cssOptima " style={{color: "#555555"}}
											  to="/reset_password">{translate( "Haben Sie Ihr Passwort vergessen?" )}</Link>
									</div>
								</Form>
							</div>
						</Col>
					</Row>
					<hr />
										<section>
											<div className="pt5  flex flex-row justify-center items-center">
								    <div style={{maxWidth: "500px", zIndex: 101}} className="tc pa2 ma2 flex flex-row justify-between items-center">
									<img src={"/image/Icon_Kontakt.jpg"} alt="Kontakt" style={{width: "100px", height: "100px"}} />
									<div className="tl f6 pl2 "><p className="f5 fw6 cssOptima">{translate("Nehmen Sie Kontakt zu uns auf.")} </p>
										 {htmr(translate("Gerne beantworten wir Ihre Fragen und <br/> unterstützen Sie bei Ihrem Anliegen."))}
										<p className="f6 "> <Icon name={"phone"} style={{color: "#917236"}} />: <a href="tel:+492418881345" style={{color: "#917236"}}>+49 241 8881 345</a> | <Icon name={"mail"} style={{color: "#917236"}} />: <a href="mailto:customer-sales-de@lindt.com" style={{color: "#917236"}}>customer-sales-de@lindt.com</a> </p> </div>

									</div>
									</div>
					</section>
					<div className="center mw6 pb3">
						{/*<Message>
							<div className="b">{translate("LOGIN_NOTICE_HEADER")}</div>

							<div>{translate("LOGIN_NOTICE")}</div>

							<div className={"tc pt3"}>
								<Button as={Link} to={"/request_password"}>{translate("Passwort anfordern")}</Button>
							</div>
						</Message>*/}
					</div>

					{/*					<div className="tc pb5">
						<div className="black-50">{translate( "No account yet?" )}</div>
						<Link to="/customer_registration">{translate( "register new account" )}</Link> <br />
						{config.customer_enabling &&
						<Link to="/customer_enabling">{translate( "access with offline account" )}</Link>}
					</div> */}

					{config.b2cLink && <div>
						<hr />
						<div className="tc">
							<a href={config.b2cLink}>{translate( "B2C Shop" )}</a>
						</div>
					</div>}
				</div>

				<div className="lindtColorScheme fixed bottom-0 left-0 right-0">

					<Menu fluid
						  secondary
						  size="small">
						<Menu.Item className="cssRoboto lindtColorScheme" as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "data"} )}}
								   position="right">{translate( "Data Policy" )}</Menu.Item>
						<Menu.Item className="cssRoboto lindtColorScheme" as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "imprint"} )}}>{translate( "imprint" )}</Menu.Item>
						{/*<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "agb"} )}}>AGB</Menu.Item> */}
					</Menu>

				</div>


				<Modal
					open={query.modal && query.slug}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug={query.slug} />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "data"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="datenschutz" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "imprint"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="impressum" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "agb"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="agb" />
					</Modal.Content>
				</Modal>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/lindtbShop/pages/LoginPage.js